import { useState, useEffect } from 'react';
import contentData from './content.json';

const contentfulToArticles = (articleItems) => {
  const articles = {};
  articleItems.items.forEach((a) => {
    const name = a.fields.name;
    const data = a.fields.article;
    articles[name] = data;
  });
  return articles;
};

const contentfulToSections = (metaverseItems) => {
  const items = metaverseItems.items.map((i) => {
    return {
      category: i.fields.category,
      order: i.fields.order,
      subtitle: i.fields.subtitle,
      description: i.fields.description,
      compatible: i.fields.compatible,
      name: i.fields.title,
      url: i.fields.url,
      image: i.fields.image.fields.file.url,
    }
  });

  const categories = {};
  items.forEach((i) => {
    if (!categories[i.category]) {
      categories[i.category] = [];
    }
    categories[i.category].push(i);
  });
  return Object.keys(categories).map((c) => {
    return {
      category: c,
      items: categories[c].sort((a, b) => a.order - b.order)
    }
  }).sort((a, b) => {
    return a.category.toUpperCase() < b.category.toUpperCase() ? -1 : a.category.toUpperCase() > b.category.toUpperCase() ? 1 : 0;
  });
};

const contentfulToPromo = (promoItems) => {
  const items = promoItems.items.map((i) => {
    return {
      order: i.fields.order,
      text: i.fields.text,
      url: i.fields.url,
      image: i.fields.image?.fields.file.url,
      bigText: i.fields.bigText
    }
  });
  return items.sort((a, b) => a.order - b.order);
};

export default function useContentful() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({ metaverseItems: [], promo: [], articles: {} });

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const dataFromContentful = contentData;
      const parsed = {metaverseItems: contentfulToSections(dataFromContentful.metaverseItems), promo: contentfulToPromo(dataFromContentful.promo), articles: contentfulToArticles(dataFromContentful.articles)};
      setData(parsed);
    } catch (e) {
      setData({ metaverseItems: [], promo: [], articles: []});
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { metaverseItems: data.metaverseItems, promo: data.promo, articles: data.articles, isLoading };
}

